import {
  Collapse,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import React, { useState } from "react";
import { ExpandLess, ExpandMore, StarBorder } from "@mui/icons-material";
import { NavLink } from "react-router-dom";

export default function DrawerItem({ item }) {
  const [open, setOpen] = useState(true);
  const { childrens } = item;

  const handleClick = () => {
    setOpen(!open);
  };

  if (childrens) {
    return (
      <>
        <ListItemButton onClick={handleClick} divider>
          <ListItemText primary={item.title} />
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={open} timeout="auto">
          <List component="div" disablePadding>
            {childrens.map((child) => (
              <NavLink to={child.path} key={child.path}>
                <ListItemButton sx={{ pl: 4 }}>
                  <ListItemText primary={child.title} />
                </ListItemButton>
              </NavLink>
            ))}
          </List>
        </Collapse>
      </>
    );
  } else
    <ListItemButton>
      <ListItemText primary={item.title} />
    </ListItemButton>;
}
